import React from 'react';
import { useTranslation } from 'react-i18next';
import Pill from 'components/Pill';
import Icon from 'components/Icon';
export default function NextUpPill() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Pill, {
    background: "highlight"
  }, /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    dimmed: true,
    name: "nav-right",
    scale: 0,
    mr: "xxxs"
  }), t('asset_next_up'));
}